<template>
  <currency-input
    class="underline-mode"
    v-if="mode === 'underline'"
    v-model="inputVal"
    :allow-negative="false"
    v-currency="{
      precision: 0,
      valueRange: { min: 0, max: 100 },
      currency: { suffix: '%' },
      allowNegative: false,
    }"
  />
  <input
    class="read-only-mode"
    v-else-if="mode === 'readOnly'"
    v-model="inputVal"
    v-currency="{
      precision: 0,
      valueRange: { min: 0, max: 100 },
      currency: { suffix: '%' },
      allowNegative: false,
    }"
  />
  <input
    class="normal-mode"
    v-else
    v-model="inputVal"
    :allow-negative="false"
    placeholder="ระบุ"
    v-currency="{
      precision: 0,
      valueRange: { min: 0, max: 100 },
      currency: { suffix: '%' },
      allowNegative: false,
    }"
  />
</template>

<script>
export default {
  name: "Percentage",
  model: {
    prop: "value",
    event: "change",
  },
  props: ["value", "mode"],
  data() {
    return {};
  },
  computed: {
    inputVal: {
      get() {
        return this.value || 0;
      },
      set() {
        if (this.$el) {
          this.$emit("change", this.$el.$ci.numberValue);
        }
      },
    },
  },
  methods: {},
};
</script>

<style scoped>
.underline-mode {
  text-decoration: underline;
  border: none;
  padding: 0;
  background: transparent;
  text-align: end;
  color: #29a9e2;
  cursor: pointer;
  width: 100%;
}

.read-only-mode {
  border: none;
  padding: 0;
  background: transparent;
  pointer-events: none;
  text-align: end;
  width: 100%;
}

.normal-mode {
  border-radius: 5px;
  height: 56px;
  width: 100%;
  max-width: 352px;
  padding: 15px 16px;
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid #acb1bf;
  background: transparent;
}
</style>
